import { useEffect, useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Switch
} from 'components'
import { IItensSegurancaSubItens } from 'services/GST/PesquisaPorContrato'

import { IhandleChangeSubItensListProps } from './documentacaoCollapse'

interface ITableGerenciamentoSubItensProps {
  tableData: IItensSegurancaSubItens[]
  handleChangeSubItensList: (props: IhandleChangeSubItensListProps) => void
  indexItemSegurancaTable: number
}

export const TableGerenciamento: React.FC<ITableGerenciamentoSubItensProps> = ({ 
  tableData, 
  handleChangeSubItensList,
  indexItemSegurancaTable 
}) => {
  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="20px" align="center">
                Item
              </TableCellStyled>
              <TableCellStyled minwidth="20px">Descrição</TableCellStyled>
              <TableCellStyled minwidth="30px" align="center">
                OK
              </TableCellStyled>
              <TableCellStyled minwidth="30px" align="center">
                Infração
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="center">
                UFIR
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="center">
                Total
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.length > 0 &&
              (
                rowsPerPage > 0
                  ? tableData.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  : tableData
              )?.map((row, index) => (
                <TableRowStyled key={`${index}-${row?.txDescricaoSubitem}`}>
                  <TableCellStyled align="center">{row?.nuItemGrid}</TableCellStyled>
                  <TableCellStyled>{row?.txDescricaoSubitem}</TableCellStyled>
                  <TableCellStyled align="center">
                    <Switch
                      state={row?.flOk}
                      handleChange={(e, value) => handleChangeSubItensList({
                        indexItemSegurancaTable: indexItemSegurancaTable,
                        indexSubItem: (page * rowsPerPage) + index,
                        value: value
                      })}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.cdInfracao}
                  </TableCellStyled>
                  <TableCellStyled align="center">{row?.qtUfir}</TableCellStyled>
                  <TableCellStyled align="center">{row?.vlTotal}</TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
